import { render, staticRenderFns } from "./PersonalDataForm.vue?vue&type=template&id=3c62f5cf&scoped=true"
import script from "./PersonalDataForm.vue?vue&type=script&lang=js"
export * from "./PersonalDataForm.vue?vue&type=script&lang=js"
import style0 from "./PersonalDataForm.vue?vue&type=style&index=0&id=3c62f5cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c62f5cf",
  null
  
)

export default component.exports